import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  ITEM_FUNCTION_TPYE,
  PET_SUB_FUNCTION_TYPE,
  PET_SUB_FUNCTION_TYPE_MAP,
  STATUS_SUB_FUNCTION_TYPE,
} from '@typings/store/storeItemFunctionType';
import { IstoreItem } from '@typings/store/storeItem.interface';
import { useCollection } from '@nandorojo/swr-firestore';
import { CollectionPath } from '@typings/collections.enum';
import {
  defaultStatusList,
  IstatusItem,
  statusType,
} from '@typings/status/statusItem.interface';

const StatusDescription = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 11px;
`;
const Chip = styled.div`
  padding: 4px 6px;
  border-radius: 50px;
  width: fit-content;
  background-color: var(--subColor);
  color: var(--primaryColor);
`;

// HP/MP 아이템의 서브 타입에 따른 설명 레이블 생성
function getStatusLabel(data: IstoreItem, statusValue: string): string {
  const isHp = data.statusId === statusType.HP;
  const isMp = data.statusId === statusType.MP;

  if (!isHp && !isMp) return statusValue;

  const subType = data.statusSubFunctionType;
  const isRestore = subType === STATUS_SUB_FUNCTION_TYPE.RESTORE_CURRENT;

  if (isHp) return isRestore ? '현재 체력 회복' : '최대 체력 (피통)';
  return isRestore ? '현재 마력 회복' : '최대 마력 (마통)';
}

type Props = {
  data?: IstoreItem | null;
};
function ItemTypeSec({ data }: Props) {
  const [statusValue, setStatusValue] = useState('');

  const { data: statusList } =
    useCollection<IstatusItem>(`${CollectionPath.STATUS}`) || defaultStatusList;

  useEffect(() => {
    if (!data) return;

    const filterStatus =
      statusList && statusList.filter((item) => item.id === data.statusId);

    setStatusValue(
      filterStatus && filterStatus[0] ? filterStatus[0].value : '',
    );
  }, [statusList, data]);

  const itemTypeTextMap = {
    [ITEM_FUNCTION_TPYE.STATUS]: '스탯보정 아이템',
    [ITEM_FUNCTION_TPYE.MYROOM]: '마이룸 꾸미기 아이템',
    [ITEM_FUNCTION_TPYE.DEFAULT]: '기본 아이템',
    [ITEM_FUNCTION_TPYE.USERGIFT]: '아이템 만들기',
    [ITEM_FUNCTION_TPYE.PET]: '펫 전용 아이템',
    [ITEM_FUNCTION_TPYE.BETTING_CREATE]: '베팅 주제 만들기',
    [ITEM_FUNCTION_TPYE.QUEST_CREATE]: '퀘스트 만들기 아이템',
    [ITEM_FUNCTION_TPYE.RANDOM_BOX]: '랜덤박스 아이템',
    [ITEM_FUNCTION_TPYE.RANDOM_BOX_POST]: '랜덤박스 아이템',
    [ITEM_FUNCTION_TPYE.INVESTIGATION]: '탐사 지문 아이템',
  };

  return (
    <StatusDescription>
      <Chip>
        {itemTypeTextMap[data?.functionType || ITEM_FUNCTION_TPYE.DEFAULT]}
      </Chip>
      {data?.functionType === ITEM_FUNCTION_TPYE.STATUS && (
        <>
          <span>{getStatusLabel(data, statusValue)}</span>
          <span>{(data && data.addStatusValue) || 0}</span>
        </>
      )}
      {data?.functionType === ITEM_FUNCTION_TPYE.PET && (
        <>
          <span>
            {
              PET_SUB_FUNCTION_TYPE_MAP[
                data?.petFunction?.subFunctionType ||
                  PET_SUB_FUNCTION_TYPE.FILL_HUNGER
              ]
            }
          </span>
          <span>{data?.petFunction?.value}</span>
        </>
      )}
    </StatusDescription>
  );
}

export default ItemTypeSec;
